import React, { FC, lazy, ReactElement, Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import { Loader } from "./components/Loader";
import { Login } from "./pages/Login";
import { AppPage } from "./pages/AppPage";
import { MachineProvider } from "./context/MachineContext";
import { UserProvider } from "./context/UserContext";

const OrganizationsPage = lazy(() => import("./pages/OrganizationsPage"));
const MachinesPage = lazy(() => import("./pages/Machine/MachinesPage"));
const DashboardPage = lazy(() => import("./pages/DashboardPage"));
const WorkflowPage = lazy(() => import("./pages/Workflow/WorkflowPage"));
const WorkflowsPage = lazy(() => import("./pages/WorkflowsPage"));
const PredictionPage = lazy(() => import("./pages/Prediction/PredictionPage"));
const PreviewReport = lazy(() => import("./pages/Download report/DownloadPdf"));

interface IRoute {
  path: string;
  element: ReactElement;
  noSidebar?: boolean;
  childrenRoutes?: IRoute[];
}

export const Router: FC = () => {
  const fullScreenRoutes: IRoute[] = [
    { path: "/", element: <Login /> },
    { path: "/preview-report/:workflowUuid", element: <PreviewReport /> },

    // { path: "/error", element: <ErrorPage /> },
  ];

  const sidebarRoutes: IRoute[] = [
    { path: "/machines", element: <MachinesPage /> },
    { path: "/super", element: <OrganizationsPage /> },
    { path: "/workflows", element: <WorkflowsPage /> },
    { path: "/datasets", element: <DashboardPage /> },
    { path: "/workflows/:workflowUuid", element: <WorkflowPage /> },
    { path: "/prediction", element: <PredictionPage /> },

    // { path: "/wrong-organization", element: <NoAccessPage /> },
  ];

  return (
    <Routes>
      {fullScreenRoutes.map((route) => (
        <Route
          key={route.path}
          path={route.path}
          element={
            <Suspense fallback={<Loader isLoading={true} />}>
              {route.element}
            </Suspense>
          }
        />
      ))}

      {sidebarRoutes.map((route) => (
        <Route
          key={route.path}
          path={route.path}
          element={
            <UserProvider>
              <MachineProvider>
                <AppPage>
                  <Suspense fallback={<Loader isLoading={true} />}>
                    {route.element}
                  </Suspense>
                </AppPage>
              </MachineProvider>
            </UserProvider>
          }
        />
      ))}
    </Routes>
  );
};
